import React from 'react'
import { Routes, Route } from 'react-router-dom'
import MainLayout from '../layouts/MainLayout'
import ArtistsPage from '../pages/ArtistsPage'
import SongsPage from '../pages/SongsPage'
import HomePage from '../pages/HomePage'
import { BookListPage } from '../pages/BookListPage'
import { BookViewPage } from '../pages/BookViewPage'
import SafariToolbarTestPage from '../pages/SafariToolbarTestPage'

export default function AppRouter() {
  return (
    <Routes>
      <Route path="/safari-toolbar-test" element={<SafariToolbarTestPage />} />
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/artists" element={<ArtistsPage />} />
        <Route path="/books" element={<BookListPage />} />
        <Route path="/artist/:artistName" element={<SongsPage />} />
        <Route path="/book/:bookName" element={<BookViewPage />} />
      </Route>
    </Routes>
  )
}
